import React, { useEffect } from 'react';

const ChatBot = () => {
  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    script.src = 'https://d2svqkbje7nfuq.cloudfront.net/lex-web-ui-loader.min.js';
    script.async = true;
    
    // Append the script to the document head
    document.head.appendChild(script);

    script.onload = () => {
      // Initialize the chatbot once the script is loaded
      const loaderOpts = {
        baseUrl: 'https://d2svqkbje7nfuq.cloudfront.net/',
        shouldLoadMinDeps: true,
      };
      const loader = new window.ChatBotUiLoader.IframeLoader(loaderOpts);
      const chatbotUiConfig = {
        /* Example of setting session attributes on parent page
        lex: {
          sessionAttributes: {
            userAgent: navigator.userAgent,
            QNAClientFilter: ''
          }
        }
        */
      };
      loader.load(chatbotUiConfig).catch((error) => {
        console.error(error);
      });
    };

    // Cleanup the script when the component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return <div id="chatbot-container"></div>;
};

export default ChatBot;